function getHeader(countryID, lang) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  var navOwner = countryID;
  var langCode = lang;
  var URL = window.location.href;
  var domain = '';
  if (
    URL.includes('localhost') ||
    URL.includes('dev') ||
    URL.includes('test')
  ) {
    domain = 'test';
  } else if (URL.includes('preview')) {
    domain = 'stage';
  } else {
    domain = '';
  }
  var url =
    'https://hfglobal' +
    domain +
    '.parker.com' +
    '/header.js?divisionId=' +
    navOwner +
    '&langCode=' +
    langCode;

  script.async = true;
  script.src = url;
  var header = document.getElementById('header');
  header.innerHTML = '';
  header.appendChild(script);
  script.onload = () => {
    var cookies = document.cookie.split(';');
    var strenv = '';
    if (
      URL.includes('dev') ||
      URL.includes('test') ||
      URL.includes('preview') ||
      URL.includes('localhost')
    )
      strenv = 'test_';
    else strenv = 'prod_';

    document
      .getElementById('signInSection')
      ?.setAttribute('style', 'display: block !important');
    document
      .getElementById('userNameSection')
      ?.setAttribute('style', 'display: none !important');
    for (var i = 1; i <= cookies.length - 1; i++) {
      if (
        cookies[i].includes(strenv + 'login_flag') &&
        cookies[i].split('=').length > 1
      ) {
        document
          .getElementById('signInSection')
          ?.setAttribute('style', 'display: none !important');
        document
          .getElementById('userNameSection')
          ?.setAttribute('style', 'display: block !important');
      }
    }
    var signinUrl = document.getElementById('userMenu')?.href;
    signinUrl = signinUrl + '&fromEConfig=true';
    document.getElementById('userMenu')?.setAttribute('href', signinUrl);
    document.cookie =
      'eConfigURL=' +
      window.btoa(window.location.href) +
      ';domain=parker.com;path=/';
    var anchorTag = document.getElementsByTagName('a');
    for (var i = 0; i < anchorTag.length; i++) {
      if (anchorTag[i].innerHTML == 'Log Out') {
        var signoutTag = anchorTag[i];
        break;
      }
    }
    if (signoutTag) {
      var signoutUrl = signoutTag.href;
      signoutUrl = signoutUrl + 'fromEConfig=true';
      signoutTag.setAttribute('href', signoutUrl);
    }
  };
  window.eval('function overrideLanguageChange(){ return false; }');
  return script;
}

const getFooter = (countryID, lang) => {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  var langCode = lang;
  var URL = window.location.href;
  var domain = '';
  if (
    URL.includes('localhost') ||
    URL.includes('dev') ||
    URL.includes('test')
  ) {
    domain = 'test';
  } else if (URL.includes('preview')) {
    domain = 'stage';
  } else {
    domain = '';
  }
  var url =
    'https://hfglobal' +
    domain +
    '.parker.com' +
    '/footer.js?divisionId=' +
    countryID +
    '&langCode=' +
    langCode;

  script.async = true;
  script.src = url;
  var footer = document.getElementById('footer');
  footer.innerHTML = '';
  footer.appendChild(script);
};

export { getHeader, getFooter };
